import Landing from "../features/landing";

const LandingPage = () => {
  return (
    <div className="relative bg-black overflow-x-hidden"> 
      
      <div
        style={{ background: "rgba(0, 182, 128, 0.32)" }}
        className="absolute blur-[100px] sm:blur-[132px] left-[-10rem] sm:left-[-5rem] top-[3rem] sm:top-[5.88rem] h-[20rem] w-[20rem] sm:h-[31.25rem] sm:w-[31.25rem] z-0" 
      ></div>
      <div
        style={{ background: "rgba(0, 182, 128, 0.32)" }}
        className="absolute blur-[100px] sm:blur-[132px] right-[-10rem] sm:right-[-5rem] top-[25rem] sm:top-[37.75rem] h-[20rem] w-[20rem] sm:h-[31.25rem] sm:w-[31.25rem] z-0" 
      ></div>
      
      <div className="relative z-10"> 
        <Landing />
      </div>
    </div>
  );
};

export default LandingPage;
